export const CUSTOM_STAT_PREFIX = '[Custom]';
export const CUSTOM_STAT_CATEGORY_PREFIX = `${CUSTOM_STAT_PREFIX} Custom Stat_`;
export const CUSTOM_STAT_CATEGORY = `${CUSTOM_STAT_PREFIX} Custom Stat`;
export const CUSTOM_QUERY_MANAGER_CATEGORY = `${CUSTOM_STAT_PREFIX} Query Manager`;
export const CUSTOM_QUERY_MANAGER_CATEGORY_FOR_API = 'custom';
export const CUSTOM_USER_INTEGRATION_CATEGORY_PREFIX = `${CUSTOM_STAT_PREFIX} User Integration_`;
